import React, { useEffect, useRef, useState } from 'react';
import { GetStaticPropsContext } from "next";
import { getAgency, getAllPricingFeatureCategories } from "queries/Pricing";
import Container from "components/core/Container";
import 'rc-slider/assets/index.css';
import { ITextBlock } from "blocks/text/TextBlock";
import TextBlockContent from "blocks/text/TextBlockContent";
import { IPricingPlan } from "components/pricing/Plan";
import Features from "components/pricing/Features/Features";
import CtaBlock, { ICtaBlock } from "blocks/cta/CtaBlock";
import { withAppLayout } from "components/core/withAppLayout";
import { createSubscription } from "components/hooks/usePreview";
import { request } from "components/hooks/useQuery";
import useRouter from "components/hooks/useRouter";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import nextI18NextConfig from "../../../next-i18next.config";
import { IFaq } from "../../blocks/faq/Faq";
import useTrans from "components/hooks/useTrans";

export async function getStaticProps(context: GetStaticPropsContext) {
    const query = {
        query: getAgency(context.locale),
        preview: context.preview,
        withAppData: true,
        locale: context.locale
    };

    const data = await createSubscription(context, query);

    return {
        props: {
            data: data,
            seo: data.initialData.agency.seo,
            appData: {
                ...data.initialData.header,
                ...data.initialData.footer,
            },
            ...(await serverSideTranslations(context.locale, ['common'], nextI18NextConfig)),
        }
    };
}

type Props = {
    agency: {
        hero: ITextBlock[],
        callToAction: ICtaBlock,
        faq: IFaq[]
    },
    allPricingPlans: IPricingPlan[],
};

function ServiceSuite(props: Props) {
    const { locale } = useRouter();
    const { t } = useTrans();
    const featuresRef = useRef(null);
    const hero = props.agency.hero[0];
    const callToAction = props.agency.callToAction;
    const plans = props.allPricingPlans;
    const [pending, setPending] = useState(false);
    const [featureCategories, setFeatureCategories] = useState([]);

    useEffect(() => {
        setPending(true);
        request({
            query: getAllPricingFeatureCategories(locale, "agency")
        }).then((data) => {
            setFeatureCategories(data.allPricingFeatureCategories);
        })
            .catch((err) => console.log(err))
            .finally(() => {
                setPending(false);
            });
    }, []);

    return (
        <>
            <div className={"bg-primary-25"}>
                <Container>
                    <section className={"pt-28 pb-10 gap-x-32"}>
                        <TextBlockContent {...hero} />
                    </section>
                </Container>
            </div>
            <div className={"bg-white"} ref={featuresRef}>
                <Container overflowable={true}>
                    <section className={"py-6 lg:mt-10"}>
                        <Features
                            featureCategories={featureCategories}
                            plans={plans}
                            pending={pending}
                            isSalesPage={true}
                        />
                    </section>
                </Container>
                <section>
                    <CtaBlock {...callToAction} />
                </section>
            </div>
        </>
    );
}

export default withAppLayout(ServiceSuite);